import MFeedMasonry from "./blocks/m_feed_masonry"
import Html from "./blocks/html"
import MExcerpt from "./blocks/m_excerpt"
import MAccordion from "./blocks/m_accordion"
import MAuthorCollapsible from "./blocks/m_author_collapsible"
import MDivider from "./blocks/m_divider"
import MDownloadTeaser from "./blocks/m_downloadteaser"
import MDownloadList from "./blocks/m_download_list"
import MHero from "./blocks/m_hero"
import MHeroSlider from "./blocks/m_hero_slider"
import MHeroCollectionsSlider from "./blocks/m_hero_collection_slider"
import MImage from "./blocks/m_image"
import MImagecarousel from "./blocks/m_imagecarousel"
import MImagecarouselModalSlider from "./blocks/m_imagecarousel_modal_slider"
import MImagecarouselAnalyse from "./blocks/m_imagecarousel_analyse"
import MMediaPodcast from "./blocks/m_media_podcast"
import MMediaVideo from "./blocks/m_media_video"
import MMediaTextSlider from "./blocks/m_media_text_slider"
import MOpener from "./blocks/m_opener"
import MQuoteSwitch from "./modules/m_quote_switch"
import MRichtext from "./blocks/m_richtext"
import MTextimage from "./blocks/m_textimage"
import MTextimageQuote from "./blocks/m_textimage_quote"
import MTextmedia from "./blocks/m_textmedia"
import MMultiColumnTeasers from "./blocks/m_multi_column_teasers"
import MGreetings from "./blocks/m_greetings"
import MHeadline from "./blocks/m_headline"
import MHighlightCarousel from "./blocks/m_highlight_carousel"
import MHighlightTeaser from "./blocks/m_highlight_teaser"
import MHeroCollectionSlider from "./blocks/m_hero_collection_slider"
import MScienceCarousel from "./blocks/m_science_carousel"
import MScienceCategoriesOverview from "./blocks/m_science_categories_overview"
import MSocialWall from "./blocks/m_socialwall"
import MSponsoring from "./blocks/m_sponsoring"
import EpKapitelueberschrift from "./blocks/ep_kapitelueberschrift"
import MTab from "./blocks/m_tab"
import MSubNavigation from "./blocks/m_subnavigation"
import MBreadcrumb from "./blocks/m_breadcrumb"
import MCalendarOverview from "./modules/m_calendar_overview"
import MCardGrid from "./blocks/m_cardgrid"
import MCardGridSwitchMilestone from "./blocks/m_card_grid_switch_milestone"
import MCardGridSwitchPerson from "./blocks/m_card_grid_switch_person"
import MCardrow from "./blocks/m_cardrow"
import MSpeakerGrid from "./blocks/m_speakergrid"
import MNewsletter from "./modules/m_newsletter"
import MRelatedLinks from "./blocks/m_related_links"
import MSandwich from "./blocks/m_sandwich"
import MShare from "./blocks/m_share"
import MStreet from "./blocks/m_street"
import MSweatRate from "./modules/m_sweat_rate"
import MTextHighlight from "./blocks/m_texthighlight"
import MTextHighlightAlternative from "./blocks/m_texthighlight_alternative"
import MTextHighlightImage from "./blocks/m_texthighlight_image"
import EpHtml from "./blocks/ep_html"
import EpImage from "./blocks/ep_image"
import EpMehrAnzeigen from "./blocks/ep_mehr_anzeigen"
import UserPanel from "./modules/user_panel"
import MUserPanelOverview from "./modules/m_user_panel_overview"
import MBackLink from "./modules/m_back_link"
import PersonalizedSuggestions from "./modules/personalized_suggestions"
import MIntextTeaser from "./blocks/m_intext_teaser"
import MMultiFormatSlider from "./modules/m_multi_format_slider"
import MMultiFormatStream from "./modules/m_multi_format_stream"
import MMultiFormatStreamRemote from "./modules/m_multi_format_stream_remote"
import MMultiFormatSliderRemote from "./modules/m_multi_format_slider_remote"
import MNestedHomepageFeedRemote from "./modules/m_nested_homepage_feed_remote"
import MExternalContent from "./modules/m_external_content"
import MContentSlider from "./blocks/m_content_slider"
import MModalInfo from "./blocks/m_modal_info"

import MLiveBlog from "./blocks/m_liveblog.js"
import MSuperbanner from "./blocks/m_superbanner"

import WebComponentStairs from "./modules/web_component_stairs"
import MCardFactImage from "./blocks/m_card_fact_image";
import MCardGridCTA from "./blocks/m_card_grid_cta";
import MCardGridFacts from "./blocks/m_card_grid_facts";
import MCardGridTopic from "./blocks/m_card_grid_topic";
import MCardrowCTA from "./blocks/m_card_row_cta";
import MCardRowFacts from "./blocks/m_card_row_facts";
import MHeroTeaser from "./blocks/m_hero_teaser";
import MIllustrationCopy from "./blocks/m_illustration_copy";
import MImagecarouselSpecial from "./blocks/m_imagecarousel_special";
import MPowerBi from "./blocks/m_power_bi";
import MSocialMediaSubBrand from "./blocks/m_social_media_subbrand";
import MCardHighlights from "./modules/m_card_highlights";
import MCardNews from "./modules/m_card_news";
import MVideoCards from "./modules/m_video_cards"
import MPodigeePlayer from "./modules/m_podigee_player"
import MComparisonTable from "./modules/m_comparison_table"
import MButton from "./modules/m_button"

export default {
  m_feed_masonry: MFeedMasonry,
  html: Html,
  m_excerpt: MExcerpt,
  m_accordion: MAccordion,
  m_author_collapsible: MAuthorCollapsible,
  m_divider: MDivider,
  m_download_list: MDownloadList,
  m_downloadteaser: MDownloadTeaser,
  m_hero: MHero,
  m_hero_slider: MHeroSlider,
  m_hero_collection_slider: MHeroCollectionsSlider,
  m_image: MImage,
  m_imagecarousel:
    process.env.USE_IMAGE_CAROUSEL_MODAL_SLIDER !== "true"
      ? MImagecarousel
      : MImagecarouselModalSlider,
  m_imagecarousel_analyse: MImagecarouselAnalyse,
  m_media_podcast: MMediaPodcast,
  m_media_video: MMediaVideo,
  m_media_text_slider: MMediaTextSlider,
  m_opener: MOpener,
  m_quote: MQuoteSwitch,
  m_richtext: MRichtext,
  m_textimage: MTextimage,
  m_textmedia: MTextmedia,
  m_textimage_quote: MTextimageQuote,
  m_intext_teaser: MIntextTeaser,
  m_multi_column_teasers: MMultiColumnTeasers,

  ep_bild: EpImage,
  ep_video: MMediaVideo,
  ep_text: MRichtext,
  ep_kapitelueberschrift: EpKapitelueberschrift,
  ep_html: EpHtml,
  ep_mehr_anzeigen: EpMehrAnzeigen,

  m_greetings: MGreetings,
  m_headline: MHeadline,
  m_highlight_carousel: MHighlightCarousel,
  m_highlight_teaser: MHighlightTeaser,
  m_highlight_text_teaser: MHighlightTeaser,
  m_science_carousel: MScienceCarousel,
  m_science_categories_overview: MScienceCategoriesOverview,
  m_socialwall: MSocialWall,
  m_sponsoring: MSponsoring,
  m_tab: MTab,
  m_subnavigation: MSubNavigation,
  m_breadcrumb: MBreadcrumb,
  m_calendar_overview: MCalendarOverview,
  m_cardgrid: MCardGrid,
  m_cardgrid_switch: MCardGridSwitchPerson,
  m_card_grid_switch_milestone: MCardGridSwitchMilestone,
  m_card_grid_switch_person: MCardGridSwitchPerson,
  m_cardrow: MCardrow,
  m_external_content: MExternalContent,
  m_multi_format_slider:
    process.env.USE_REMOTE_COLLECTION_API !== "true"
      ? MMultiFormatSlider
      : MMultiFormatSliderRemote,
  m_multi_format_stream:
    process.env.USE_REMOTE_COLLECTION_API !== "true"
      ? MMultiFormatStream
      : MMultiFormatStreamRemote,

  m_nested_homepage_feed: MNestedHomepageFeedRemote,
  m_speakergrid: MSpeakerGrid,

  m_related_links: MRelatedLinks, //MFurtherLinks in DFB Context
  m_sandwich: MSandwich,
  m_street: MStreet,
  m_share: MShare,
  m_text_highlight: MTextHighlight,
  m_text_highlight_alternative: MTextHighlightAlternative,
  m_text_highlight_image: MTextHighlightImage,
  m_newsletter: MNewsletter,
  m_sweat_rate: MSweatRate,
  m_content_slider: MContentSlider,
  m_rtemodalwindow: MModalInfo,

  m_live_blog: MLiveBlog,
  m_ad_superbanner: MSuperbanner,

  m_back_link: MBackLink,
  m_userpanel_module: UserPanel,
  m_userpanel_menu: MUserPanelOverview,
  m_personalized_suggestions: PersonalizedSuggestions,

  web_component_stairs: WebComponentStairs,

  /** new DFB Components **/
  m_card_fact_image: MCardFactImage,
  m_card_cta: MCardGridCTA,
  m_card_grid_facts: MCardGridFacts,
  m_card_topic: MCardGridTopic,
  m_card_row_facts: MCardRowFacts,
  m_hero_teaser: MHeroTeaser,
  m_illustration_copy: MIllustrationCopy,
  m_power_bi: MPowerBi,
  m_card_highlights: MCardHighlights,
  m_card_news: MCardNews,
  m_video_cards: MVideoCards,
  m_podigee: MPodigeePlayer,
  m_comparison_table: MComparisonTable,
  m_cta_button: MButton,
    //check if really needed
    m_card_row_cta: MCardrowCTA,
    m_imagecarousel_special: MImagecarouselSpecial,
    m_social_media_subbrand: MSocialMediaSubBrand,
}